const toDate = (value) => {
  if(!value) return null;
  return value instanceof Date ? value : value.toDate();
}

const combineDateAndTime = (dateValue, timeValue) => {
  const date = toDate(dateValue);
  if(!date) return null;

  const dateTime = new Date(date);
  const time = toDate(timeValue);
  if(time){
    dateTime.setHours(time.getHours(), time.getMinutes(), 0, 0);
  }
  else {
    dateTime.setHours(0, 0, 0, 0);
  }

  return dateTime;
}

export const formatDateRange = (startAt, endAt) => {
  if(!startAt || !endAt) return '';

  const sameDay = startAt.toDateString() === endAt.toDateString();
  const dateOptions = {month: 'short', day: 'numeric', year: 'numeric'};
  const startDate = startAt.toLocaleDateString('en-US', dateOptions);
  const endDate = endAt.toLocaleDateString('en-US', dateOptions);

  if(sameDay){
    return startDate;
  }

  return `${startDate} - ${endDate}`;
}

export const buildTripSummaries = (events = {}) => {
  const summaries = {};

  for(const event of Object.values(events || {})){
    for(const tripId of event.tripIds || []){
      const startAt = combineDateAndTime(event.startDate, event.startTime);
      if(!startAt) continue;

      const endAt = combineDateAndTime(event.endDate || event.startDate, event.endTime || event.startTime) || startAt;
      const summary = summaries[tripId] || {
        eventCount: 0,
        startAt,
        endAt,
        friendIds: []
      };
      const friendIds = new Set(summary.friendIds);

      summary.eventCount += 1;
      if(startAt < summary.startAt) summary.startAt = startAt;
      if(endAt > summary.endAt) summary.endAt = endAt;

      for(const friendId of event.friendIds || []){
        friendIds.add(friendId);
      }
      summary.friendIds = Array.from(friendIds);

      summaries[tripId] = summary;
    }
  }

  return summaries;
}
